import {useEffect, useRef} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {Outlet} from "react-router-dom";

import {withRoleRequired} from "../Components/AccessBoundary/withRoleRequire";
import {fetchNewTickets} from "../Components/DevIT/DevITSlice";
import ErrorBoundary from "../Components/errorBoundary/ErrorBoundary";
import {fetchData} from "../hook/axios.hook";
import {fetchDesigners, fetchOrgStructures} from "../slices/CatalogsSlice";
import {clientsFetched, fetchAllRoutes, fetchUsers} from "../slices/PersonSlice";
import {getUser, selectCurrentUserId} from "../slices/UserSlice";
import {IT_MANAGERS_IDS} from "../utilities/generalConstants.js/generalConstants";
import {toaster} from "../utilities/hooks/toaster";

const IndexPage = () => {
  const dispatch = useDispatch();
  const currentUserId = useSelector(selectCurrentUserId);
  const isITManager = IT_MANAGERS_IDS.includes(currentUserId);
  const {t} = useTranslation();
  useEffect(() => {
    try {
      dispatch(getUser());
      dispatch(fetchDesigners());
      dispatch(fetchOrgStructures());
      dispatch(fetchUsers());
      // dispatch(fetchAccessRoutes());
      dispatch(fetchAllRoutes());
    } catch (error) {
      console.error(error);
    }

    fetchData("/clients/getAll", "get")
      .then(res => {
        dispatch(clientsFetched(res));
      })
      .catch(() => {});
  }, []);

  const previousTicketIdsRef = useRef(new Set());
  useEffect(() => {
    if (!currentUserId || !isITManager) return;

    const getTickets = () => {
      dispatch(fetchNewTickets())
        .unwrap()
        .then(resp => {
          const tickets = Array.isArray(resp?.data) ? resp.data : [];
          const newTickets = tickets.filter(t => !previousTicketIdsRef.current.has(t.ticketId));

          if (newTickets.length > 0) {
            toaster.warning(t("New DevIT tickets", [newTickets.length]), 3000);
          }
          previousTicketIdsRef.current = new Set(tickets.map(ticket => ticket.ticketId));
        })
        .catch(err => console.error(err));
    };

    getTickets();

    const intervalId = setInterval(getTickets, 15 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, [currentUserId, isITManager]);

  return (
    <>
      <ErrorBoundary>
        {/* <div className="App__container"> */}
        <Outlet />
        {/* </div> */}
      </ErrorBoundary>
    </>
  );
};

export default withRoleRequired(IndexPage);

// export default IndexPage;
